import React from 'react';
import ErrorIcon from '@mui/icons-material/Error';
import { TextInp } from './styled';

const Input = props => {
  return (
    <>
      <TextInp
        {...props}
        value={props.val}
        onChange={props.handlechange}
        onBlur={props.handleblur}
        error={props.touched && props.inperror}
        // sx={{
        //   '&  .MuiFormHelperText-root': {
        //     background: 'transparent',
        //   },
        // }}

        helperText={
          props.touched && props.inperror ? (
            <>
              <ErrorIcon sx={{ mr: 1, fontSize: '1rem', verticalAlign: 'middle' }} />
              {props.inperror}
            </>
          ) : null
        }
      />
    </>
  );
};

export default Input;
